import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-45875747"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: ""
};
const _hoisted_2 = {
  class: "cms-card-block"
};
const _hoisted_3 = {
  key: 1,
  style: {
    "width": "100%",
    "display": "flex",
    "align-items": "center"
  }
};
import ActionHeader from '@/views/common/ActionHeader/index.vue';
import FormItem from '../../../actorsAndDirectors/Components/FormItem/index.vue';
import Buttons from '@/components/Buttons/index.vue';
import { useI18n } from 'vue-i18n';
import { useVodLanguages } from '@/utils/cacheData';
import { scrollIntoView } from '@/utils/tools';
import { messageBox } from '@/utils/validate';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    returnBackFn: {
      type: Function
    }
  },

  setup(__props) {
    const props = __props;
    const {
      t
    } = useI18n();
    const FormRef = ref(null);
    const headerConfig = reactive({
      title: '新增点播分类属性',
      btnList: [{
        label: '返回',
        func: () => {
          props.returnBackFn();
        }
      }]
    });
    const formConfig = reactive({
      formList: [[{
        label: '语言',
        prop: 'language',
        widgetType: 'Select',
        required: true,
        itemSlot: true,
        rules: [{
          required: true,
          message: t('请选择语言'),
          trigger: 'change'
        }],
        controller: (value, data, config) => {
          return true;
        }
      }, {
        label: '分类属性名称',
        prop: 'name',
        widgetType: 'input',
        required: true,
        itemSlot: true,
        rules: [{
          required: true,
          message: t('请输入分类属性名称'),
          trigger: 'blur'
        }],
        controller: (value, data, config) => {
          return true;
        }
      }]],
      formData: [{
        language: 'en',
        name: ''
      }],
      rules: {},
      headerButtonsList: [{
        label: '添加语言',
        func: () => {
          formConfig.formData.push({
            language: '',
            name: ''
          });
        }
      }],
      loading: false
    });

    const onConfirm = () => {
      FormRef.value.validate(valid => {
        if (valid) {
          console.log(formConfig.formData);
        } else {
          scrollIntoView();
        }
      });
    };

    const onCancel = () => {
      props.returnBackFn();
    };

    const onDelete = index => {
      messageBox('确定删除这条数据吗?').then(async () => {
        formConfig.formData.splice(index, 1);
      });
    };

    const LanguageSelectList = ref([]); // 获取所有语言

    const getAllLanguages = async () => {
      const res = await useVodLanguages();
      LanguageSelectList.value = res;
    };

    getAllLanguages();
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_ButtomBtns = _resolveComponent("ButtomBtns");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(ActionHeader, {
        config: headerConfig
      }, null, 8, ["config"]), _createElementVNode("div", _hoisted_2, [_createVNode(Buttons, {
        class: "header-btns mg-b--20",
        "buttons-list": formConfig.headerButtonsList
      }, null, 8, ["buttons-list"]), _createVNode(_component_el_form, {
        model: formConfig.formData,
        ref_key: "FormRef",
        ref: FormRef,
        class: "search-form"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.formData, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index
          }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formConfig.formList, (formItem, formIndex) => {
            return _openBlock(), _createBlock(FormItem, {
              col: ['25%', '25%', '25%', '25%'],
              "form-item": formItem,
              "form-data": item,
              c_index: index
            }, {
              itemSlot: _withCtx(scope => [scope.prop == 'language' ? (_openBlock(), _createBlock(_component_el_select, {
                key: 0,
                modelValue: item.language,
                "onUpdate:modelValue": $event => item.language = $event,
                placeholder: _ctx.$t('请选择'),
                disabled: index === 0
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(LanguageSelectList.value, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "disabled"])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_input, {
                modelValue: item.name,
                "onUpdate:modelValue": $event => item.name = $event
              }, null, 8, ["modelValue", "onUpdate:modelValue"]), index > 0 ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                onClick: $event => onDelete(index)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('删除')), 1)]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true)]))]),
              _: 2
            }, 1032, ["form-item", "form-data", "c_index"]);
          }), 256))]);
        }), 128))]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_ButtomBtns, {
        style: {
          "margin-top": "50px"
        },
        onOnCancel: onCancel,
        onOnConfirm: onConfirm
      })])]);
    };
  }

});